import $ from "jquery";
import App from "../src/App";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Intro text animation
gsap.fromTo(
  ".intro__title, .intro__subtitle",
  { y: 20, opacity: 0 },
  {
    y: 0,
    opacity: 1,
    stagger: 0.5,
  },
);

// Intro scroll icon animation
gsap.fromTo(
  ".intro__scroll path",
  {
    d: 'path("M 24 24 v 0")',
  },
  {
    d: 'path("M 24 24 v 110")',
    delay: 1,
  },
);
gsap.fromTo(
  ".intro__scroll rect",
  {
    "stroke-dasharray": 408,
    "stroke-dashoffset": 408,
  },
  {
    "stroke-dasharray": 408,
    "stroke-dashoffset": 0,
    delay: 1,
    duration: 2,
  },
);

// Pin second section animation
$(".js-pin-helper").each(function () {
  gsap.timeline({
    scrollTrigger: {
      trigger: $(this),
      scrub: 1,
      start: "top top",
      pin: true,
      pinSpacing: false,
    },
  });
});

// Click for scroll animation
$(".intro__scroll").click(function () {
  $(window).scrollTop($(".js-scroll-helper").offset().top);
});

$(window).scroll(function () {
  if ($(".js-scroll-helper").offset().top - $(window).scrollTop() < 0) {
    $("header").addClass("dark");
  } else {
    $("header").removeClass("dark");
  }
});
